package navigation.root.home

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.quickbooks.domain.QuickbooksClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.features.notification.domain.repository.NotificationRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.qbauth.domain.repository.QbAuthRepository
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.AddTaskUseCase
import com.essntl.features.task.domain.use_case.DeleteTaskUseCase
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.toastmanager.ToastManager
import core.datastore.data.DatastoreManager
import ui.home.HomeEvent
import ui.home.HomeState
import ui.home.HomeViewModel

class HomeScreenModel(
    authRepository: AuthRepository,
    profileRepository: ProfileRepository,
    taskRepository: TaskRepository,
    qbAuthRepository: QbAuthRepository,
    quickbooksClient: QuickbooksClient,
    notificationRepository: NotificationRepository,
    val toastManager: ToastManager,
    val loadingManager: LoadingManager,
    addTaskUseCase: AddTaskUseCase,
    updateTaskUseCase: UpdateTaskUseCase,
    deleteTaskUseCase: DeleteTaskUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    datastoreManager: DatastoreManager,
) : StateScreenModel<HomeState>(HomeState()) {
    val homeViewModel =
        HomeViewModel(
            authRepository = authRepository,
            profileRepository = profileRepository,
            taskRepository = taskRepository,
            qbAuthRepository = qbAuthRepository,
            quickbooksClient = quickbooksClient,
            notificationRepository = notificationRepository,
            toastManager = toastManager,
            addTaskUseCase = addTaskUseCase,
            updateTaskUseCase = updateTaskUseCase,
            deleteTaskUseCase = deleteTaskUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            datastoreManager = datastoreManager,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: HomeEvent) = homeViewModel.onEvent(event)
}
